import { ORGANISATION_PROPOSAL } from 'actions/types';
import { baseStore } from './common/baseStore';

export default baseStore(ORGANISATION_PROPOSAL);
